<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>
                <v-layout align-center>
                  <v-img
                    :src="getImgUrl('Amadeus_Logo')"
                    height="40px"
                    width="40px"
                    contain
                  >
                  </v-img>
                  AMADEUS {{ $t('Ticket-Transfer') }}
                </v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
             <v-btn
  color="white"
  flat
  @click="officeIdDialog = true"
>
  <v-icon left>add</v-icon>
  {{ $t('Add-OfficeID') }}
</v-btn>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>...</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form
                      ref="formaktarim"
                      id="formaktarim"
                      method="post"
                      enctype="multipart/form-data"
                      v-model="valid"
                      lazy-validation
                    >
                      <input
                        hidden
                        type="file"
                        id="file"
                        ref="file"
                        multiple
                        v-on:change="handleFileUpload()"
                      />
                    </v-form>
                    <v-btn
                      :loading="false"
                      :disabled="false"
                      color="info"
                      dark
                      @click="addFiles()"
                    >
                      <v-icon color="white" left>attach_file</v-icon>
                      {{ $t('Select-Transfer-File') }}
                    </v-btn>
                    <div v-show="load2">
                      <v-btn
                        small=""
                        fab
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="SubmitFile()"
                        color="info"
                        dark
                      >
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span> {{$t('Transfer-Selected')}} </span>
                      </v-tooltip>
                    </div>
                    <!-- <div v-if="status.loading">
                      <v-layout>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </div> -->
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4> </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert
                    :value="true"
                    :color="alertcolor"
                    icon="check_circle"
                    outline
                  >
                    {{ alertmessage }}
                  </v-alert>
                </v-flex>

                <v-dialog v-model="load3" hide-overlay persistent width="400">
                  <v-card color="primary" dark>
                    <v-card-text>
                        {{ $t('Please-Wait') }} ...
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                      ></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-card>
          </v-container>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{
                  $t("Transferred-Tickets")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search3"
                  :label="$t('Search')"
                  append-icon="search"
                ></v-text-field>
              </v-toolbar>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 50]"
                  :loading="progress"
                  :items="itemsok"
                  :search="search3"
                >
                  <v-progress-linear
                    slot="progress"
                    indeterminate
                  ></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                      <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                  
                    {{ $t('No-records-searched-for', { value: search3}) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="red">
                <v-toolbar-title>{{
                  $t("Tickets-Not-Transferred")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search4"
                  :label="$t('Search')"
                  append-icon="search"
                ></v-text-field>
              </v-toolbar>

              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 500]"
                  :loading="progress"
                  :items="itemsno"
                  :search="search4"
                >
                  <v-progress-linear
                    slot="progress"
                    indeterminate
                  ></v-progress-linear>

                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                      <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    {{ $t('No-records-searched-for', { value: search4}) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-snackbar
              :timeout="timeout"
              :top="y === 'top'"
              :bottom="y === 'bottom'"
              :right="x === 'right'"
              :left="x === 'left'"
              :multi-line="mode === 'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
            >
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">{{
                $t("Close")
              }}</v-btn>
            </v-snackbar>
          </v-layout>
          <v-dialog v-model="officeIdDialog" persistent max-width="500px">
  <v-card>
    <v-card-title class="headline grey lighten-2">
      {{ $t('Add-OfficeID') }}
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              label="Gds"
              v-model="officeIdForm.Gds"
              disabled
              hide-details
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              label="OfficeId"
              v-model="officeIdForm.OfficeId"
              maxlength="50"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
  <cariaracomp
    v-model="officeIdForm.CariKod"
    :etiket="$t('Currentcode_label')"
  ></cariaracomp>
</v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="officeIdDialogKapat">{{ $t('Cancel') }}</v-btn>
      <v-btn
        color="info"
        :loading="officeIdKayitLoading"
        :disabled="officeIdKayitLoading"
        @click="officeIdTanimla"
      >
        {{ $t('Add-OfficeID') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import Vue from "vue";
import logoo from "../../../../assets/control";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import axios from "axios";
import cariaracomp from "@/components/app/customcomp/cariaracomp";

export default {
  data() {
    return {
      officeIdDialog: false,
officeIdKayitLoading: false,
officeIdForm: {
  Gds: "Amadeus",
  OfficeId: "",
  CariKod: ""
},
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      search: "",
      headers: [
        {
          text: this.$t('Ticket-No'),
          value: "BiletNo",
        },
        {
          text: this.$t("Status"),
          value: "Aciklama",
        },
      ],

      itemsok: [],
      itemsno: [],

      valid: true,
      searchcari: "",
      dictionary: {
        custom: {
          masrafkodu: {
            required: () => this.$t('Please-choose'),
          },
          tarihsec: {
            required: () => this.$t('Please-choose'),
          },
          tarihsec1: {
            required: () => this.$t('Please-choose'),
          },
        },
      },

      dialogfiltre: false,

      search4: null,
      file: [],
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      load3: false,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      progress: false,
      items: [],
      load: false,
      alertcolor: "red",
      alertmessage: this.$t('file-has-been-chosen'),
      load1: true,
      load2: false,
      search3: "",
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,
    cariaracomp
  },
  watch: {
    searchcari(val) {
      val && this.carigetir(val);
    },
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.el = this.$refs.fab.$el;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  methods: {
    officeIdDialogKapat() {
  this.officeIdDialog = false;
  this.officeIdForm = {
    Gds: "Amadeus",
    OfficeId: "",
    CariKod: ""
  };
},

officeIdTanimla() {
  if (!this.officeIdForm.OfficeId || !this.officeIdForm.CariKod) {
    this.text1 = "OfficeId ve CariKod zorunludur.";
    this.snackbar = true;
    return;
  }

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params = {
    SirketKodu: credentials.SirketKodu,
    Gds: this.officeIdForm.Gds,
    OfficeId: this.officeIdForm.OfficeId,
    CariKod: this.officeIdForm.CariKod
  };

  this.officeIdKayitLoading = true;

  this.$http.post(auth.API_URL + "api/Ticket/GdsOfficeCariMapSave", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then((response) => {
    this.officeIdKayitLoading = false;
    this.text1 = response.body && response.body.ResponseMessage
      ? response.body.ResponseMessage
      : "OfficeId tanımı kaydedildi.";
    this.snackbar = true;
    this.officeIdDialogKapat();
  }, (response) => {
    this.officeIdKayitLoading = false;
    this.text1 = "Service Unavailable";
    this.snackbar = true;
  });
},
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    addFiles() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      this.file = [];
      var uploadedFiles = this.$refs.file.files;

      if (uploadedFiles.length > 0) {
        this.load2 = true;
        this.load = true;
        this.alertcolor = "success";
        this.alertmessage =
          "Toplam " + uploadedFiles.length + " " + this.$t('pcs-of-files-selected');
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.file.push(uploadedFiles[i]);
        }
      } else {
        this.alertmessage = this.$t('file-has-been-chosen');
        this.alertcolor = "red";
        this.load = false;
        this.load2 = false;
      }
    },
    SubmitFile() {
      this.load3 = true;
      this.itemsno = [];
      this.itemsok = [];
      var cred = JSON.parse(window.localStorage.getItem("credentials"));
      let formData = new FormData();
      
      for (var i = 0; i < this.file.length; i++) {
        let file = this.file[i];

        if(10485760 > file.size){
          formData.append("file[" + i + "]", file);  
        }else{
          this.snackbar = true;
          this.text1 = this.$t('The-file-size-cannot-be-larger-than-10mb.')
        }
        
      }
      formData.append("CustomerCode", cred.AnaSirketKodu);
      formData.append("TransferType", "0");
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

      axios
        .post(auth.API_URL + "api/TicketDefinitons/FileUpload", formData, {
          headers: {
            Authorization: `Bearer ${auth.getAuthHeader()}`,
          },
        })
        .then((response) => {
          if (response.data == true) {
            this.load2 = true;
            this.load = false;

            var credentials = JSON.parse(
              window.localStorage.getItem("credentials")
            );

            var params1 = {
              CompanyCode: credentials.SirketKodu,
              CustomerCode: credentials.AnaSirketKodu,
            };

            this.$http
              .post(auth.API_URL + "api/TicketStream/AmadeusStream", params1, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              })
              .then(
                (response) => {
                  this.itemsok = [];
                  this.itemsno = [];

                  response.body.forEach((element) => {
                    if (element.Status == true) {
                      this.itemsok.push(element);
                    } else {
                      this.itemsno.push(element);
                    }
                  });

                  this.text1 = this.$t('total-of-ticket-transfers-completed',{value: this.itemsok.length});
                  this.snackbar = true;
                  this.load = true;
                  this.load1 = true;
                  this.load2 = false;
                  this.load3 = false;
                },
                (response) => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable";
                    this.snackbar = true;
                    this.load1 = true;
                    this.load2 = false;
                    this.load = true;
                    this.load3 = false;
                  } else {
                    this.text1 = "Service Unavailable";
                    this.snackbar = true;
                    this.load1 = true;
                    this.load = true;
                    this.load3 = false;

                    this.load2 = false;
                  }
                }
              );
          } else {
            this.text1 = this.$t('File-transfer-failed-please-try-again');
            this.snackbar = true;
          }
        })
        .catch(function () {});
    },
    formatDate(date) {
      var str = date;
      var n = str.search(".");
      if (n == 1) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    parseDate(date) {
      if (!date) return null;
      var str = date;
      var n = str.search("-");
      var m = str.length;
      if (n == 1) {
        const [month, day, year] = date.split("-");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      } else if (m == 8) {
      } else if (n == -1 && m != 8) {
        this.dateFormatted = getDateNow1();
        this.date = getDateNow();
      } else {
        const [day, month, year] = date.split(".");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },

    onChange: onChange,
    getDateNow1: getDateNow1,
    getDateNow: getDateNow,
    git: git,
  },
};

function git(v) {
  var url =
    "#/bilet/yeni/id?" +
    "isl=get&hyolukod=" +
    v.HavayoluKodu +
    "&biletno=" +
    v.BiletNo +
    "&ucustipi=" +
    v.UcusTipi;
  window.open(url, "_blank");
}

function beforeMount() {
  this.dateFormatted = getDateNow1();
  this.date = getDateNow();
}

function onChange(v) {
  var c = v.length;
  var a = v;
  if (c == 8) {
    var b = a[4] + a[5] + a[6] + a[7] + "-" + a[2] + a[3] + "-" + a[0] + a[1];
    var ay = a[2] + a[3];
    var gun = a[0] + a[1];
    var yil = a[4] + a[5] + a[6] + a[7];

    a = new Date(b);

    if (a instanceof Date && !isNaN(a.valueOf())) {
      //şubatın 29 çekmesin
      if (ay == "02" && yil % 10 != 0 && gun == "29") {
        b = yil + "-" + ay + "-" + "28";
        this.date = b;
        this.dateFormatted = "28" + "-" + ay + "-" + yil;
        //31 nisan
      } else if (ay == "04" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
        //31 haziran
      } else if (ay == "06" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
        //31 eylül
      } else if (ay == "09" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
        //31 kasım
      } else if (ay == "11" && gun == "31") {
        b = yil + "-" + ay + "-" + "30";
        this.date = b;
        this.dateFormatted = "30" + "-" + ay + "-" + yil;
      } else {
        this.date = b;
      }
    } else {
      this.dateFormatted = null;
    }
  } else {
    this.dateFormatted = null;
  }
}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}

function getDateNow1() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "." + mm + "." + yyyy;
  return today;
}
</script>

<style>
.image-upload > input {
  display: none;
}

.image-upload img {
  width: 80px;
  cursor: pointer;
}
</style>
